import { computed as g, openBlock as s, createElementBlock as d, normalizeClass as o, createElementVNode as l, toDisplayString as n, createCommentVNode as r, Fragment as u, renderList as _ } from "vue";
/* empty css                 */
const m = ["textContent"], f = ["textContent"], v = { class: "ds-display-flex ds-flex-direction-column ds-padding-bottom-12" }, y = ["textContent"], x = ["textContent"], b = /* @__PURE__ */ Object.assign({
  name: "DsStatsBlock"
}, {
  __name: "stats-block",
  props: {
    /**
     * Title - Used for the DsSectionGroup Title
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * Subtitle - Used for the DsSectionGroup subtitle
     */
    subtitle: {
      type: String,
      default: ""
    },
    /**
     * Items - Used to render the actual Stats block
     * The `title` is the only required field, it also expects `subtitle` and `description`
     */
    items: {
      type: Array,
      validator: (t) => t.every((i) => ["metric"].every((e) => e in i)),
      required: !0
    },
    orientation: {
      type: String,
      default: "vertical",
      validator: (t) => ["vertical", "horizontal"].includes(t)
    }
  },
  setup(t) {
    const i = t, e = g(() => i.title && i.subtitle ? i.orientation === "horizontal" : !1);
    return (h, p) => (s(), d("div", {
      class: o({ "ds-grid ds-align-items-center": e.value })
    }, [
      l("div", {
        class: o({
          "ds-grid__col ds-grid__col--12 ds-lg-grid__col--5": e.value
        })
      }, [
        l("div", null, [
          t.title ? (s(), d("h2", {
            key: 0,
            class: "ds-heading ds-padding-bottom-12",
            "data-j-title": "",
            textContent: n(t.title)
          }, null, 8, m)) : r("", !0),
          t.subtitle ? (s(), d("p", {
            key: 1,
            class: "ds-text",
            "data-j-subtitle": "",
            textContent: n(t.subtitle)
          }, null, 8, f)) : r("", !0)
        ])
      ], 2),
      l("div", {
        class: o(["ds-grid ds-display-flex", {
          "ds-margin-top-48": t.title || t.subtitle,
          "ds-grid ds-lg-grid__col--6 stats-block__grid ds-lg-grid__col--offset-1 ds-md-grid__col--offset-0": e.value
        }])
      }, [
        (s(!0), d(u, null, _(t.items, (a, c) => (s(), d("div", {
          key: `item-${c}`,
          class: o(e.value ? "ds-grid__col ds-grid__col--12 ds-md-grid__col--6 ds-lg-grid__col--6" : "ds-grid__col ds-grid__col--12 ds-md-grid__col--6 ds-lg-grid__col--4"),
          "data-j-stats": ""
        }, [
          l("div", v, [
            l("h2", {
              class: "ds-heading-large ds-color-green ds-padding-bottom-12",
              "data-j-title": "",
              style: { "font-weight": "350" },
              textContent: n(a.metric)
            }, null, 8, y),
            a.description ? (s(), d("p", {
              key: 0,
              class: "ds-text",
              "data-j-subtitle": "",
              textContent: n(a.description)
            }, null, 8, x)) : r("", !0)
          ])
        ], 2))), 128))
      ], 2)
    ], 2));
  }
}), j = b;
export {
  j as default
};
